<template>
  <a
    ref="myButton"
    class="tvb-button"
    :class="[
      `tvb-button-${type ? type : 'brightness'}`,
      {'tvb-button-disabled': disabled},
    ]"
    @click.prevent="emitClick($event)"
  >
    <slot class="tvb-button-content"></slot>
  </a>
</template>
<script>
export default {
  name: 'tvb-button',
  props: {
    type: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {
    const parentNode = this.$refs.myButton.parentNode
    parentNode.addEventListener('touchstart', function() {}, {passive: true})
  },
  methods: {
    emitClick(e) {
      this.$emit('click')
    },
  },
  destroyed() {
    this.$off('click')
  },
}
</script>
<style lang="scss">
.tvb-button {
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
}
.tvb-button-scale {
  transition: transform 0.15s linear;
  &:active {
    transform: scale(0.95);
  }
}
.tvb-button-brightness {
  transition: filter 0.1s;
  &:active {
    filter: brightness(80%);
  }
}
.tvb-button-disabled {
  &:active {
    filter: none;
    transform: none;
  }
}
</style>
